import { render, staticRenderFns } from "./XpSj.vue?vue&type=template&id=cd778076&scoped=true&"
import script from "./XpSj.vue?vue&type=script&lang=js&"
export * from "./XpSj.vue?vue&type=script&lang=js&"
import style0 from "./XpSj.vue?vue&type=style&index=0&id=cd778076&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd778076",
  null
  
)

export default component.exports